import { Submission } from '../store/submission/types';
import { store } from '../store/store';
import { selectPaperStatusState } from '../store/selectors';
import { CategoryType, PaperStatusName } from '../store/paper-status/types';

export const getPaperStatusName = (submission: Submission): PaperStatusName => {
  let name = '';
  if (!submission.paper_status_id) {
    name = submission.paper_status_name ?? '';
  } else {
    const state = store.getState();
    const paperStatusById = selectPaperStatusState(state).paperStatusById;
    const paperStatus = paperStatusById[submission.paper_status_id];
    name = paperStatus.name;
  }
  return name;
};

export const getPaperStatusCategory = (submission: Submission): CategoryType => {
  let category = '';
  if (!submission.paper_status_id) {
    category = submission.paper_status_category ?? '';
  } else {
    const state = store.getState();
    const paperStatusById = selectPaperStatusState(state).paperStatusById;
    const paperStatus = paperStatusById[submission.paper_status_id];
    category = paperStatus.category;
  }
  return category;
};

export const normalizeAffinity = (value: number | string): number => (value === 'N/A' ? 0 : Number(value));
